import { uuid } from "@/lib/types";

export const META_MESSAGES_USER_ID_REGEX = /^\d{15,20}$/;

export enum CustomerBadge {
  BOOKED = "booked",
  // TODO: Add other badges
}

export enum CustomerContactInfoType {
  EMAIL = "email-address",
  PHONE = "phone-number",
  UUID = "uuid",
}

export type RawEndUserData = {
  id: string;
  tenant_id: string;
  hub_status: string;
  first_name: string | null;
  last_name: string | null;

  assignee_user_id: uuid | null;
  assignee_first_name: string | null;
  assignee_last_name: string | null;
  assignee_user_group_id: uuid | null;
  assignee_user_group_name: string | null;

  last_interaction_at: Date;
  last_interaction_id: uuid | null;
  last_interaction_is_transferred: boolean | null; // transfer badge
  last_interaction_is_active: boolean | null;
  last_interaction_is_flagged: boolean | null;
  last_interaction_resolved_by_human: boolean | null;
  last_interaction_interaction_type: string | null;
  last_interaction_event_type: string | null;
  last_interaction_flagged_event_type: string | null;
  last_interaction_call_id: uuid | null;
  last_interaction_session_id: uuid | null;
  last_interaction_session_channel: string | null;
  last_interaction_session_marketing_source: string | null;
  last_interaction_session_campaign_id: uuid | null;
  contact_info_type: string;
  contact_info_value: string;
  contact_info_unmasked_number: string | null;
  tenant_name: string;
  tenant_name_abbreviation: string | null;

  analytics_interaction_group: string | null;
  analytics_outcome: string | null;
  analytics_reason: string | null;
  analytics_lead_status: string | null;
  analytics_business_unit_id: number | null;
  text_responded: boolean | null;
  is_booked_by_other: boolean | null;

  is_unseen: boolean;
  folder_ids?: string[] | null;
  has_unresponded_text?: boolean | null;
};
